<template>
  <!--
    @name: ThemeTitle.vue
    @description: 直播主题
    @author:  GaoYu
    @time: 2020/7/31 10:14
  -->
  <div class="theme-container" v-show="themeList.length > 0">
    <div class="theme-box" v-for="(theme, key) in themeList" :key="key">
      <div class="top" v-if="themeList.length > 1">{{theme.top}}</div>
      <div class="title">{{theme.theme}}</div>
      <div class="lecturer-box">
        <div class="lecturer-item" v-for="(item, index) in theme.lecturer" :key="index">
          <div class="img"><img :src="item.circle_image" alt=""></div>
          <div class="describe-box">
            <div class="name">{{item.name}}</div>
            <div class="introduce">{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { titleFrameContent } from '@/api/live'
export default {
  name: 'ThemeTitle',
  data () {
    return {
      liveId: this.$route.params.live_id,
      themeList: []
    }
  },
  mounted () {
    this.getTitleFrame()
  },
  methods: {
    getTitleFrame () {
      titleFrameContent({
        live_id: this.liveId
      }).then(res => {
        if (res.code === this.$config.codeOk) {
          this.themeList = res.data.list
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .theme-container {
    padding: 0 16px;
    .theme-box {
      .top {
        width: 54px;
        height: 18px;
        background: #EEEEEE;
        border-radius: 0 100px 100px 0;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        text-align: center;
        line-height: 18px;
        margin-left: -16px;
        margin-bottom: 10px;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
        color: #333333;
        margin-bottom: 12px;
      }
      .lecturer-box {
        .lecturer-item {
          display: flex;
          margin-bottom: 28px;
          .img {
            img {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              overflow: hidden;
            }
          }
          .describe-box {
            flex: 1;
            margin-left: 8px;
            .name {
              height:21px;
              font-size:15px;
              font-weight:600;
              color:#333333;
              line-height:21px
            }
            .introduce {
              font-size:13px;
              font-weight:400;
              color:#999999;
              line-height:18px;
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Live/ThemeTitle.vue